import React from 'react';

// Matches documents that already carry their own <html>/<!doctype> wrapper
// (rendered emails usually do) — those are passed through untouched.
const FULL_DOCUMENT_RE = /<!doctype\s|<html[\s>]/i;

// Minimal wrap for HTML fragments so they stay legible inside the iframe:
// previously these fragments inherited the dashboard's font styles, so the
// wrapper mimics MUI body text (Roboto stack, 14px) and the 16px padding the
// old preview boxes had.
const wrapFragment = (html) => `<!doctype html>
<html>
<head>
<meta charset="utf-8">
<style>
    body {
        margin: 16px;
        font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        font-size: 14px;
        line-height: 1.43;
        color: rgba(0, 0, 0, 0.87);
        word-wrap: break-word;
    }
</style>
</head>
<body>${html}</body>
</html>`;

/**
 * Renders operator-authored / template-rendered HTML inside a fully sandboxed
 * iframe (no scripts, no same-origin access, no navigation) instead of
 * injecting it into the app's DOM. The content is untrusted — never render it
 * with dangerouslySetInnerHTML.
 *
 * Because the sandbox blocks same-origin access, the parent cannot measure the
 * document, so callers must give the iframe an explicit height via `style`.
 * Content taller than that scrolls inside the iframe.
 */
const SandboxedHtmlPreview = ({ html, title = 'HTML preview', style }) => {
    const content = html || '';
    return (
        <iframe
            sandbox=""
            srcDoc={FULL_DOCUMENT_RE.test(content) ? content : wrapFragment(content)}
            title={title}
            style={{
                display: 'block',
                boxSizing: 'border-box',
                width: '100%',
                border: '1px solid #ddd',
                background: 'white',
                ...style,
            }}
        />
    );
};

export default SandboxedHtmlPreview;
